// extracted by mini-css-extract-plugin
export var boxItems = "_20-1";
export var boxItemsLg = "_20-2";
export var button = "_20-7";
export var buttonHoverless = "_20-9";
export var buttonLg = "_20-8";
export var filterGroupBox = "_20-0";
export var icon = "_20-3";
export var iconSecondary = "_20-6";
export var iconWrapper = "_20-4";
export var iconWrapperLg = "_20-5";
export var truncatedLabel = "_20-a";